import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import HrbTranslate from '../../../components/language/HrbTranslate'
import ProductBadge from '../../../components/library/badges/ProductBadge'
import BackLink from '../../../components/library/common/BackLink';

const PresaleTitle = (props) => {
    const { presale } = props;    

    return (
        <Fragment>
            <div className='columns tickets level'>
                <div className='column is-1'>
                    <ProductBadge productCode="PRESALE" />
                </div>
                <div className='column is-8'>
                    {presale &&
                        <h1><HrbTranslate text='PresaleInfo.Headers.Title' /></h1>
                    }                    
                </div>
                <div className='column is-2'>
                    <BackLink isRight />
                </div>
                <div className='column is-1' />
            </div>            
            <div className='columns tickets level separator-border'>
                <div className='column is-1' />
                <div className='column is-10'>
                    <hr />
                </div>
                <div className='column is-1' />
            </div>
        </Fragment>
    );
}

PresaleTitle.whyDidYouRender = false;

PresaleTitle.propTypes = {
    presale: PropTypes.object,
    lang: PropTypes.string
}

export default PresaleTitle